import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { HelpContent } from '../HelpContent';
import { jsx as _jsx } from "react/jsx-runtime";
export function HtmlStepItem({
  item,
  label
}) {
  var _item$tooltip;
  return /*#__PURE__*/_jsx(FormControl, {
    label: label,
    tooltip: (_item$tooltip = item.tooltip) === null || _item$tooltip === void 0 ? void 0 : _item$tooltip.text,
    help: /*#__PURE__*/_jsx(HelpContent, {
      helpData: item.help
    }),
    children: /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: item.html
      }
    })
  });
}